import type { ComponentProps } from "react"
import { forwardRef } from "react"

type Props = ComponentProps<"svg">

export const AiDocumentIcon = forwardRef<SVGSVGElement, Props>((props, ref) => (
	<svg
		width="1em"
		height="1em"
		viewBox="0 0 16 16"
		xmlns="http://www.w3.org/2000/svg"
		ref={ref}
		{...props}
	>
		<path
			fill="currentColor"
			fillRule="evenodd"
			clipRule="evenodd"
			d="M5.5 1C4.11929 1 3 2.11929 3 3.5V4.25C3 4.66421 3.33579 5 3.75 5C4.16421 5 4.5 4.66421 4.5 4.25V3.5C4.5 2.94772 4.94772 2.5 5.5 2.5H8V5.25C8 6.76878 9.23122 8 10.75 8H13.5V12.5C13.5 13.0523 13.0523 13.5 12.5 13.5H10.75C10.3358 13.5 10 13.8358 10 14.25C10 14.6642 10.3358 15 10.75 15H12.5C13.8807 15 15 13.8807 15 12.5V7.03553C15 6.37249 14.7366 5.73661 14.2678 5.26777L10.7322 1.73223C10.2634 1.26339 9.62751 1 8.96447 1H5.5ZM13.2071 6.32843C13.2595 6.38081 13.3055 6.43841 13.3445 6.5H10.75C10.0596 6.5 9.5 5.94036 9.5 5.25V2.65548C9.56159 2.69454 9.61919 2.74051 9.67157 2.79289L13.2071 6.32843Z"
		></path>
		<path
			fill="currentColor"
			fillRule="evenodd"
			clipRule="evenodd"
			d="M3.77126 9.14369L4.04311 7.78446C4.13433 7.32833 4.53483 7 5 7C5.46517 7 5.86567 7.32833 5.95689 7.78446L6.22874 9.14369C6.26654 9.33269 6.28544 9.4272 6.33204 9.50318C6.37322 9.57032 6.42968 9.62678 6.49682 9.66796C6.5728 9.71456 6.6673 9.73346 6.85631 9.77126L8.21554 10.0431C8.67167 10.1343 9 10.5348 9 11C9 11.4652 8.67167 11.8657 8.21554 11.9569L6.85631 12.2287C6.66731 12.2665 6.5728 12.2854 6.49682 12.332C6.42968 12.3732 6.37322 12.4297 6.33204 12.4968C6.28544 12.5728 6.26654 12.6673 6.22874 12.8563L5.95689 14.2155C5.86567 14.6717 5.46517 15 5 15C4.53483 15 4.13433 14.6717 4.04311 14.2155L3.77126 12.8563C3.73346 12.6673 3.71456 12.5728 3.66796 12.4968C3.62678 12.4297 3.57032 12.3732 3.50318 12.332C3.4272 12.2854 3.33269 12.2665 3.14369 12.2287L1.78446 11.9569C1.32833 11.8657 1 11.4652 1 11C1 10.5348 1.32833 10.1343 1.78446 10.0431L3.14369 9.77126C3.3327 9.73346 3.4272 9.71456 3.50318 9.66796C3.57032 9.62678 3.62678 9.57032 3.66796 9.50318C3.71456 9.4272 3.73346 9.3327 3.77126 9.14369Z"
		></path>
	</svg>
))
